import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { bootstrapAuth } from '../features/auth/bootstrapAuth';

/**
 * Restores session from localStorage / refresh cookie before rendering routes.
 */
export default function AuthBootstrap({ children }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);

  useEffect(() => {
    bootstrapAuth(dispatch);
  }, [dispatch]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--df-bg, #f7f5f1)',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return children;
}
